module.exports = __webpack_public_path__ + "img/standing-man.267085cb.png";